import { render, staticRenderFns } from "./AgentsByRisk.vue?vue&type=template&id=bee727e6&scoped=true&"
import script from "./AgentsByRisk.vue?vue&type=script&lang=js&"
export * from "./AgentsByRisk.vue?vue&type=script&lang=js&"
import style0 from "./AgentsByRisk.vue?vue&type=style&index=0&id=bee727e6&lang=css&scoped=true&"
import style1 from "./AgentsByRisk.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee727e6",
  null
  
)

export default component.exports